module.exports = __webpack_public_path__ + "img/logo.63356d51.svg";